import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { deactivateAccount } from "../api/auth"
import { errorMessage } from "../types"

export default function AccountSection() {
  const { logout } = useAuth()
  const navigate = useNavigate()
  const [confirmDeactivation, setConfirmDeactivation] = useState(false)
  const [deactivatingAccount, setDeactivatingAccount] = useState(false)
  const [accountError, setAccountError] = useState<string | null>(null)

  async function handleDeactivateAccount() {
    if (deactivatingAccount) return
    setDeactivatingAccount(true)
    setAccountError(null)
    try {
      await deactivateAccount()
      logout()
      void navigate("/")
    } catch (err) {
      setAccountError(errorMessage(err))
    } finally {
      setDeactivatingAccount(false)
    }
  }

  return (
    <section>
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Account</h2>
      <div className="bg-white rounded-xl shadow-sm p-6">
        <p className="text-sm text-gray-500 mb-4">
          Deactivating your account hides your profile, list, and gifts. Sign in
          with your existing password to restore them. Keep your password safe:
          email recovery is not available yet.
        </p>
        {accountError && (
          <p role="alert" className="text-sm text-red-600 mb-4">
            {accountError}
          </p>
        )}
        {confirmDeactivation ? (
          <div className="flex flex-wrap items-center gap-3">
            <span className="text-sm text-gray-700">Are you sure?</span>
            <button
              onClick={() => {
                void handleDeactivateAccount()
              }}
              disabled={deactivatingAccount}
              className="text-sm text-white bg-red-600 hover:bg-red-700 px-4 py-1.5 rounded-lg disabled:opacity-50 transition-colors"
            >
              {deactivatingAccount
                ? "Deactivating..."
                : "Yes, deactivate my account"}
            </button>
            <button
              onClick={() => {
                setConfirmDeactivation(false)
                setAccountError(null)
              }}
              disabled={deactivatingAccount}
              className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
            >
              Cancel
            </button>
          </div>
        ) : (
          <button
            onClick={() => setConfirmDeactivation(true)}
            className="text-sm text-red-600 hover:text-red-800 font-medium transition-colors"
          >
            Deactivate account
          </button>
        )}
      </div>
    </section>
  )
}
